
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting errors returned when there are issues with OAuth.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='OAuth errors' subtitle='Guide to troubleshooting OAuth errors' mdxType="Header" />
    <p>{`For information on troubleshooting OAuth errors in Link not related to a specific error code, see `}<a parentName="p" {...{
        "href": "/docs/link/troubleshooting/#oauth-not-working"
      }}>{`Link troubleshooting: OAuth not working`}</a>{`.`}</p>
    <h4 {...{
      "id": "incorrect_oauth_nonce"
    }}><strong parentName="h4">{`INCORRECT_OAUTH_NONCE`}</strong></h4>
    <ErrorReference type='OAUTH_ERROR' error='INCORRECT_OAUTH_NONCE' subtitle="An incorrect OAuth nonce was supplied when re-initializing Link." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`During the OAuth flow, Link must be initialized, the user must be handed off to the institution's OAuth authorization page, and then Link must be re-initialized for the user to complete the Link flow. This error can occur if a different nonce is supplied during the re-initialization process than was originally supplied to Link for the first initialization step.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INCORRECT_OAUTH_NONCE-1' mdxType="Checkbox">
        <p>{`When re-initializing Link, make sure to use the same nonce that was used to originally initialize Link for that Item.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "incorrect_link_token"
    }}><strong parentName="h4">{`INCORRECT_LINK_TOKEN`}</strong></h4>
    <ErrorReference type='OAUTH_ERROR' error='INCORRECT_LINK_TOKEN' subtitle="An incorrect Link token was supplied when re-initializing Link." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`During the OAuth flow, Link must be initialized, the user must be handed off to the institution's OAuth authorization page, and then Link must be re-initialized for the user to complete the Link flow. This error can occur if a different `}<inlineCode parentName="li">{`link_token`}</inlineCode>{` is supplied during the re-initialization process than was originally supplied to Link for the first initialization step.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INCORRECT_LINK_TOKEN-1' mdxType="Checkbox">
        <p>{`When re-initializing Link, make sure to use the same `}<inlineCode parentName="p">{`link_token`}</inlineCode>{` that was used to originally initialize Link for that Item.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "oauth_state_id_already_processed"
    }}><strong parentName="h4">{`OAUTH_STATE_ID_ALREADY_PROCESSED`}</strong></h4>
    <ErrorReference type='OAUTH_ERROR' error='OAUTH_STATE_ID_ALREADY_PROCESSED' subtitle="The OAuth state has already been processed." server client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`During the OAuth flow, Link must be initialized, the user must be handed off to the institution's OAuth authorization page, and then Link must be re-initialized for the user to complete the Link flow. This error can occur if the OAuth state ID used during re-initialization of Link has already been used.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='ALREADY_PROCESSED-1' mdxType="Checkbox">
        <p>{`When re-initializing Link, make sure to use a unique OAuth state ID for each Link instance.`}</p>
      </Checkbox>
      <Checkbox checklistId='ALREADY_PROCESSED-2' mdxType="Checkbox">
        <p>{`When re-initializing Link, make sure to correctly set the `}<inlineCode parentName="p">{`receivedRedirectUri`}</inlineCode>{` as described in the `}<a parentName="p" {...{
            "href": "/docs/link/oauth/#reinitializing-link"
          }}>{`re-initializing Link`}</a>{` section of the OAuth Guide. Plaid will automatically extract the OAuth state ID from the `}<inlineCode parentName="p">{`receivedRedirectUri`}</inlineCode>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "oauth_state_id_not_found"
    }}><strong parentName="h4">{`OAUTH_STATE_ID_NOT_FOUND`}</strong></h4>
    <ErrorReference type='OAUTH_ERROR' error='OAUTH_STATE_ID_NOT_FOUND' subtitle="The OAuth state id could not be found." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`oauth_state_id`}</inlineCode>{` is invalid, expired, or does not match the institution it was originally issued for.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Make sure the `}<inlineCode parentName="p">{`oauth_state_id`}</inlineCode>{` you are using is the one most recently issued for this Link session, and that it is being passed back to the same institution it was originally issued for.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "incorrect_oauth_nonce",
        level: 4,
        title: "INCORRECT_OAUTH_NONCE",
      },
{
        id: "incorrect_link_token",
        level: 4,
        title: "INCORRECT_LINK_TOKEN",
      },
{
        id: "oauth_state_id_already_processed",
        level: 4,
        title: "OAUTH_STATE_ID_ALREADY_PROCESSED",
      },
{
        id: "oauth_state_id_not_found",
        level: 4,
        title: "OAUTH_STATE_ID_NOT_FOUND",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
